import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_checkbox-default",
  "use": "icon_checkbox-default-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_checkbox-default\"><path d=\"M19 3.00002H5L3.0004 3L3 5.00002V19L3.00076 21L5 21H19L21 21L21 19V5.00002V3.00001L19 3.00002Z\" stroke=\"currentColor\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol